import {BASE_MODULES} from "@designer/python-environment";
import {DesignColumnPanelV3, setupDesignColumnPanelV3, mkDesignerHookSpec} from "@designer/components/DesignColumnPanelV3";
import PyDefUtils from "PyDefUtils";
import type {Component, ComponentConstructor } from "@runtime/components/Component";
import { Kws, pyCallable, pyNone } from "@Sk";
import { s_new } from "@runtime/runner/py-util";
import { getCssPrefix } from "@runtime/runner/legacy-features";

const {Link} = BASE_MODULES["anvil"];


export const DesignLinkV3 = Sk.misceval.buildClass(BASE_MODULES["anvil"], function($gbl, $loc) {
    $loc["__new__"] = PyDefUtils.funcFastCall((args: [ComponentConstructor], kws?: Kws) => {
        const self = (Link.tp$getattr(s_new) as pyCallable).tp$call(args, kws) as Component;

        const updateDesignName = (s: Component, n:string) => {
            const textProp = s._anvil.getPropJS("text");
            const iconProp = s._anvil.getPropJS("icon");
            const e = s._anvil.element.find(`div.${getCssPrefix()}link-text`);
            e.find(".anvil-designer-empty-component-message").remove();
            if (!s._anvil.inlineEditing && !textProp && !iconProp && (!s._anvil.components || !s._anvil.components.length)) {
                e.append($('<span class="anvil-designer-empty-component-message">').text(s._anvil.designName));
                e.first().css('display', 'inline-block');
            }
        };
        self._anvil.updateDesignName = updateDesignName;
        return setupDesignColumnPanelV3(self, kws);
    });
    const oldHookSpec = Link.prototype.anvil$hookSpec;
    $loc.anvil$hookSpec = Object.assign(Object.create(oldHookSpec), mkDesignerHookSpec(oldHookSpec));

}, "DesignLinkV3", [Link]) as ComponentConstructor;
